import { resetMap } from "./map.js";

/**
 * Initializes the UI components for the single location map page.
 */
export function initUi() {
  const industryInfo = document.getElementById("industry-detail");
  const registerForm = document.getElementById("register-form");
  const resetButton = document.getElementById("reset-map");

  if (industryInfo) {
    industryInfo.addEventListener("click", (e) => {
      // Use event delegation to catch clicks on the contact button
      if (e.target && e.target.matches(".contact-btn")) {
        e.preventDefault();
        const ipName = e.target.dataset.name;
        const fieldIpName = registerForm?.querySelector("#field_ip_name");
        if (ipName && fieldIpName) {
          fieldIpName.value = ipName;
        }
        registerForm?.classList.add("shown");
      }
    });
  }

  if (registerForm) {
    const closeButton = registerForm.querySelector(".close");
    closeButton?.addEventListener("click", () => {
      registerForm.classList.remove("shown");
    });
  }

  if (resetButton) {
    resetButton.addEventListener("click", (e) => {
      e.preventDefault();
      resetMap();
    });
  }
}
